module.exports = __webpack_public_path__ + "media/images/weather/149_day-64261189098f18e73816041b0068a3d6.png";